// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenSwapNativeInput
 */
export interface TokenSwapNativeInput {
    /**
     * 
     * @type {string}
     * @memberof TokenSwapNativeInput
     */
    fromUserAccount: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenSwapNativeInput
     */
    toUserAccount: string | null;
    /**
     * 
     * @type {number}
     * @memberof TokenSwapNativeInput
     */
    amount: number;
}

/**
 * Check if a given object implements the TokenSwapNativeInput interface.
 */
export function instanceOfTokenSwapNativeInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fromUserAccount" in value;
    isInstance = isInstance && "toUserAccount" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function TokenSwapNativeInputFromJSON(json: any): TokenSwapNativeInput {
    return TokenSwapNativeInputFromJSONTyped(json, false);
}

export function TokenSwapNativeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenSwapNativeInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromUserAccount': json['fromUserAccount'],
        'toUserAccount': json['toUserAccount'],
        'amount': json['amount'],
    };
}

export function TokenSwapNativeInputToJSON(value?: TokenSwapNativeInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromUserAccount': value.fromUserAccount,
        'toUserAccount': value.toUserAccount,
        'amount': value.amount,
    };
}

